import * as React from 'react';
import { HotelFormConnected } from '@weddingspot/ws-core-components';
import { CheckoutContext } from './utils/CheckoutContext';

const styles = require('./CheckOutPage.module.scss');

interface Props {
    hotelIds: string[];
    onSuccess: () => void;
}

const RFPForm = (props: Props) => {
    const { submittedInquiryData, setIsRequested, setRFPFormElement } = React.useContext(CheckoutContext);

    const defaultFormValue = {
        email: submittedInquiryData.email,
        firstName: submittedInquiryData.first_name,
        lastName: submittedInquiryData.last_name,
        phoneNumber: submittedInquiryData.phone_number,
    };

    return (
        <div className={styles.inquiryWrapper}>
            <div className={styles.rfpForm}>
                <HotelFormConnected
                    type='checkout'
                    onClose={() => null}
                    onSuccess={props.onSuccess}
                    handleRoomCountSubmit={() => null}
                    handleClickedSpecifyGuestRooms={() => null}
                    csnVenueData={props.hotelIds.map((i) => ({ id: i }))}
                    defaultFormValue={defaultFormValue}
                    hideButtons={true}
                    leadSource={'room blocks search'}
                    onSubmitting={(submit: boolean) => setIsRequested(submit)}
                    onFormInit={(el: HTMLFormElement | null) => setRFPFormElement(el)}
                />
            </div>
        </div>
    );
};

export default RFPForm;
